export default "__VITE_ASSET__CjfvHo0x__"